import { Car, WriteCar } from '@/modules/car/types';

export const MapViewToWrite = (car: Car): WriteCar => ({
  car_id: car.id,
  model: car.model,
  registration_number: car.registrationNumber
});
